import React, { useState, useEffect } from "react";
// import { LoadingOutlined } from '@ant-design/icons';
// import { Spin } from 'antd';
import { Switch, Route, useLocation } from "react-router-dom";
import Topbar from "../../scenes/global/Topbar";
import Sidebar from "../../scenes/global/Sidebar";
import Dashboard from "../../scenes/dashboard";
// import Team from "../../scenes/team";
import LoanRequestList from "../../scenes/loan-request-list";
import Invoices from "../../scenes/invoices";
import Contacts from "../../scenes/contacts";
import Bar from "../../scenes/bar";
import Form from "../../scenes/form";
import Line from "../../scenes/line";
import Pie from "../../scenes/pie";
import FAQ from "../../scenes/faq";
import Geography from "../../scenes/geography";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "../../theme";
import Calendar from "../../scenes/calendar/calendar";
import Loan from "../../scenes/loan";
import AcceptedLoans from "../../scenes/accepted-loans";
import PendingAcceptance from "../../scenes/pending-acceptance";
import DelayedPayments from "../../scenes/delayed-payments";
import Agreements from "../../scenes/agreements";
import Analytics from "../../scenes/analytics";
import Subscription from "../../scenes/subscription";
import Profile from "../../scenes/profile";
import LoanRequestGrid from "../../scenes/loan-request-grid";
import { Link } from "react-router-dom";
import AdobeSign from "../../scenes/AdobeSign";
import { SearchProvider } from "../../admin/search-context";
import Messaging from "../../borrower/loan/message";
import Cookies from "js-cookie";
import MyProfile from "./myprofile";
import DocumentBuilder from "../../scenes/documentBuilder";
import LPropLoan from "../../scenes/profile/lproploan";
import PersonalLoanMarketplace from "../../scenes/profile/personalLoans";
import TestCharge from "../../admin/loan/test-charge";
import ManageCases from "../../scenes/manage-cases";
import LenderPortalDashboard from "../bank-statement-portal/LenderPortalDashboard";
import "./lender-rebrand.css";
import "./lender-mobile.css";

// const antIcon = (
//   <LoadingOutlined
//     style={{
//       fontSize: 24,
//     }}
//     spin
//   />
// );

function DashboardLayout() {
  const [theme, colorMode] = useMode();
  const { pathname } = useLocation();

  useEffect(() => {
    document.body.classList.add("sl-lender-view");
    return () => document.body.classList.remove("sl-lender-view");
  }, []);
  const [isSidebar, setIsSidebar] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = React.useState("");

  useEffect(() => {
    console.log("setting token param");
    // Function to get the value of a URL parameter by name
    const getUrlParameter = (name) => {
      name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
      const regex = new RegExp("[\\?&]" + name + "=([^&#]*)");
      const results = regex.exec(window.location.search);
      return results === null
        ? ""
        : decodeURIComponent(results[1].replace(/\+/g, " "));
    };

    // Get the token parameter from the URL
    const tokenParam = getUrlParameter("token");

    // Check if a token is present in the URL
    if (tokenParam) {
      // Store the token in cookies
      console.log(tokenParam);
      Cookies.set("token", tokenParam, { expires: 720 }); // Set an expiration if needed
    }
  }, []);

  // const handleRouteClick = () => {
  //   setIsLoading(true);
  //   // You can add a timeout here to simulate a loading process
  //   setTimeout(() => {
  //     setIsLoading(false);
  //   }, 5000);
  // };

  const [userDetails, setUserDetails] = useState(null);

  const getUserDetails = async () => {
    try {
      const response = await fetch(
        "https://www.smart-lend.com/api/profile/getUserDetails",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${Cookies.get("token")}`,
          },
        }
      );
      if (response.status === 200) {
        const json = await response.json();
        setUserDetails(json.User);
        Cookies.set("email", json.User.email);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getUserDetails();
  }, []);

  return (
    <SearchProvider value={{ search, setSearch }}>
      <ColorModeContext.Provider value={colorMode}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <div className="app sl-lender-shell">
            <Sidebar isSidebar={isSidebar} />
            <main className="content">
              <Topbar setIsSidebar={setIsSidebar} userDetails={userDetails} />
              {/* {isLoading && <Spin indicator={antIcon} />} */}
              <div className="sl-lender-page" data-page={pathname.split("/")[1]}>
                <Switch>
                  {/* <Link to="/dashboard" onClick={handleRouteClick}> */}
                  <Route path="/dashboard" component={Dashboard} />
                  {/* </Link> */}
                  {/* <Link to="/loan" onClick={handleRouteClick}> */}
                  <Route path="/loan" component={Loan} />
                  {/* </Link> */}
                  <Route path="/loan-request" component={LoanRequestList} />
                  <Route path="/accepted-loans" component={AcceptedLoans} />
                  <Route
                    path="/pending-acceptance"
                    component={PendingAcceptance}
                  />
                  <Route path="/l-payments" component={DelayedPayments} />
                  <Route path="/analytics" component={Analytics} />
                  <Route path="/agreements" component={Agreements} />
                  <Route path="/subscription" component={Subscription} />
                  <Route path="/profile" component={Profile} />
                  <Route path="/l-messages" component={Messaging} />
                  <Route path="/l-profile" component={MyProfile} />
                  <Route path="/l-document-builder" component={DocumentBuilder} />
                  <Route path="/loan-request-grid" component={LoanRequestGrid} />
                  <Route path="/adobe-sign" component={AdobeSign} />
                  <Route path="/l-prop-loan-request" component={LPropLoan} />
                  <Route
                    path="/l-personal-loan-marketplace"
                    component={PersonalLoanMarketplace}
                  />
                  <Route path="/l-manual-giro" component={TestCharge} />
                  <Route path="/l-manage-cases" component={ManageCases} />
                  <Route
                    path="/l-bank-statement-portal"
                    component={LenderPortalDashboard}
                  />
                </Switch>
              </div>
            </main>
          </div>
        </ThemeProvider>
      </ColorModeContext.Provider>
    </SearchProvider>
  );
}

export default DashboardLayout;
